import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {
  displayEmail?: string;
  authors?: any;
};

export const CorrespondingAuthorDisplay: React.FC<IProps> = ({
  displayEmail,
  authors
}) => {
  const authorDetails = authors?.find(
    (author: any) => author?.email === displayEmail
  );
  return (
    <Flex
      flexDirection="column"
      justifyContent="space-between"
      backgroundColor="surfacePrimaryFill"
      padding={4}
    >
      <Text textStyle="headingItem">
        {`${authorDetails?.firstName}  ${authorDetails?.lastName}`}
      </Text>{' '}
      <Text
        textStyle="textBody"
        noOfLines={1}
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {displayEmail}
      </Text>
    </Flex>
  );
};
